import graphql from "refractor/graphql";
export default graphql;